import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

const OrderItemForm = ({ onSave, selectorderitem }) => {
  const [formData, setFormData] = useState({
    productId: '',
    weight: '',
    goldRate: '',
    totalAmount: ''
  });

  useEffect(() => {
    if (selectorderitem) {
      setFormData(selectorderitem);
    } else {
      setFormData({ productId: '', weight: '', goldRate: '', totalAmount: '' });
    }
  }, [selectorderitem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData); // Send data up
  };

  return (
    <>
      <div className="mb-3 fw-bold fs-5">Order Item Form</div>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="productId">
              <Form.Label>Product ID</Form.Label>
              <Form.Control
                type="text"
                name="productId"
                value={formData.productId}
                onChange={handleChange}
                placeholder="Enter product ID"
                required
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group controlId="weight">
              <Form.Label>Weight (g)</Form.Label>
              <Form.Control
                type="number"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
                placeholder="Enter weight"
                required
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group controlId="goldRate">
              <Form.Label>Gold Rate</Form.Label>
              <Form.Control
                type="number"
                name="goldRate"
                value={formData.goldRate}
                onChange={handleChange}
                placeholder="Enter gold rate"
                required
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group controlId="totalAmount">
              <Form.Label>Total Amount</Form.Label>
              <Form.Control
                type="number"
                name="totalAmount"
                value={formData.totalAmount}
                onChange={handleChange}
                placeholder="Enter total amount"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex gap-2">
          <Button type="submit" variant="success">
            {selectorderitem ? 'Update' : 'Create'}
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={() =>
              setFormData({ productId: '', weight: '', goldRate: '', totalAmount: '' })
            }
          >
            Clear
          </Button>
        </div>
      </Form>
    </>
  );
};

export default OrderItemForm;